import {
   RefundConfiguration,
   RefundConfigurationQuery,
} from '@dreryk/egabinet-appointment-advance-payment-frontend-api';

import { useCqrsFind } from '@dreryk/command-query-react-common';
import { commonTranslationKeys } from '@dreryk/react-common';
import { LoaderSpinner, Message, MessageType } from '@dreryk/react-components';

type AdvancePaymentsSettingsFormLoaderRenderProps = {
   refundConfiguration: RefundConfiguration | null;
   refetchRefundConfiguration: VoidFunction;
};

type AdvancePaymentsSettingsFormLoaderProps = {
   children: (renderProps: AdvancePaymentsSettingsFormLoaderRenderProps) => JSX.Element;
};

export const AdvancePaymentsSettingsFormLoader = (props: AdvancePaymentsSettingsFormLoaderProps): JSX.Element => {
   const {
      data: refundConfiguration,
      loading: refundConfigurationLoading,
      error: refundConfigurationError,
      fetching: refundConfigurationFetching,
      refetch: refetchRefundConfiguration,
   } = useCqrsFind<RefundConfiguration>(() => new RefundConfigurationQuery());

   if (refundConfigurationLoading || refundConfigurationFetching) {
      return <LoaderSpinner />;
   }

   if (refundConfigurationError) {
      return (
         <Message
            testId={'failedToFetchRefundConfiguration'}
            label={commonTranslationKeys.unexpectedErrorHasOccurred}
            type={MessageType.NEGATIVE}
            displayIndicator
         />
      );
   }

   return props.children({
      refundConfiguration: refundConfiguration,
      refetchRefundConfiguration: refetchRefundConfiguration,
   });
};
